import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { PerfectScrollbarDirective } from './perfect-scrollbar.directive'
import { AsyncListDirective } from '@shared/directives/async-list.directive'
import { InputLengthConstraintDirective, TextareaLengthConstraintDirective } from './length-constraint.directive'
import { AutocompleteFieldValidator } from './autocomplete-field-validator.directive'
import { NumbersOnlyDirective } from './numbers-only.directive'
import { ScrollableDirective } from './scrollable.directive'
import { MacAddressDirective } from './mac-address.directive'

@NgModule({
  declarations: [
    AsyncListDirective,
    PerfectScrollbarDirective,
    InputLengthConstraintDirective,
    TextareaLengthConstraintDirective,
    AutocompleteFieldValidator,
    NumbersOnlyDirective,
    ScrollableDirective,
    MacAddressDirective,
  ],
  imports: [CommonModule],
  exports: [
    AsyncListDirective,
    PerfectScrollbarDirective,
    InputLengthConstraintDirective,
    TextareaLengthConstraintDirective,
    AutocompleteFieldValidator,
    NumbersOnlyDirective,
    ScrollableDirective,
    MacAddressDirective,
  ],
})
export class DirectiveModule {}
